module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("juzZ0"))).then(() => parcelRequire('ja5ev'));